import { ManifestServiceFlags } from '../ManifestServiceFlags';

import { EditorPointerService } from '../EditorPointerService';
import { ManifestServiceStats } from '../ManifestServiceStats';
import {
  IManifestChangeDetection,
  NoopManifestChangeDetection,
} from '../ManifestChangeDetection';
import { ManifestStore } from '../stores';
import { ClientSpecMapService } from '../sharedServices';
import { IVirtualManifestBuilderProps } from '../api';
import { VirtualElementProvider } from '../api/providers/VirtualElementProvider';
import { DependenciesContributor } from '../dependencies';
import type { EditorPointerServiceAPI } from '@wix/editor-document-logic-api';

export class PlatformManifestService {
  public readonly dependenciesContributor = new DependenciesContributor();

  public readonly virtualElementProvider: VirtualElementProvider;

  public readonly manifestStore: ManifestStore;

  /**
   * TODO: fix this as soon as possible
   * we need to use single EditorPointerService instance
   * maybe it might be fixed when manifest services are migrated to new repo with dependency injection system
   */
  readonly #editorPointerService =
    new EditorPointerService() as unknown as EditorPointerServiceAPI;

  constructor(
    private readonly manifestServiceFlags: ManifestServiceFlags = new ManifestServiceFlags(),
    private readonly manifestChangeDetection: IManifestChangeDetection = new NoopManifestChangeDetection(),
    private readonly manifestServiceStats: ManifestServiceStats = new ManifestServiceStats(),
  ) {
    this.manifestStore = new ManifestStore(
      this.dependenciesContributor,
      this.#editorPointerService,
    );

    this.virtualElementProvider = new VirtualElementProvider(
      this.dependenciesContributor,
      this.manifestStore,
      this.#editorPointerService as unknown as EditorPointerServiceAPI,
      this.manifestChangeDetection,
      this.manifestServiceFlags,
      this.manifestServiceStats,
    );
  }

  getManifestStore() {
    return this.manifestStore;
  }

  buildVirtualElement(props: IVirtualManifestBuilderProps) {
    return this.virtualElementProvider.buildVirtualElement(props);
  }
}
